import { downloadFiles } from "./download.files";
import { reportMedia } from "./gallery.media";
import { getInspectionSections } from "./inspection.report";

export async function downloadInspectionReport(product) {
  if (String(product?.inspection_status || "").toLowerCase() === "skipped") {
    await downloadFiles(reportMedia(product, "inspection_report"));
    return { failedPhotos: 0 };
  }
  const inspectionInfo = product?.inspection_report || {};
  if (
    !getInspectionSections(inspectionInfo).some(
      (section) => section.items.length,
    )
  ) {
    throw new Error(
      "Inspection checkpoint data is not available for this vehicle.",
    );
  }
  const [
    { pdf },
    { default: InspectionReportPdf, reportPhotos, prepareReportPhotos },
  ] = await Promise.all([
    import("@react-pdf/renderer"),
    import("../components/pdf/inspection.report.pdf"),
  ]);
  const { sources, failed } = await prepareReportPhotos(
    reportPhotos(inspectionInfo, product),
  );
  const blob = await pdf(
    <InspectionReportPdf
      inspectionInfo={inspectionInfo}
      usedCarInfo={product}
      photoSources={sources}
    />,
  ).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const reference =
    inspectionInfo.reference_no ||
    inspectionInfo.car_plate_no ||
    product.id ||
    "vehicle";
  link.href = url;
  link.download = `DCAR-inspection${String(reference).replace(/[^a-zA-Z0-9_-]+/g, "-")}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  return { failedPhotos: failed };
}
